<script>
export default {
    props: {
        codpart: {type: String}, 
    },

    data () {
        return {
            foneToSend: null,
            newNumber: null,
            part: null,
        }
    },

    computed: {

    },

    methods: {
        async loadPart(){
            await this.$store.dispatch('loadPart', { id: this.codpart } )

            if (this.$store.getters.getPart) {
                this.part = {...this.$store.getters.getPart[0]}
            }
        },

        handleCloseMessage () {
            this.MESSAGE = false;
            this.closeForm();
        },

        handleConfirmMessage () {
            window.open(this.link, "_blank"); 
            this.MESSAGE = false;
            this.closeForm();
        },

        closeModal () {
            this.$emit('closeform', null)
        },

        handleConfirmar(){
            let number = null
            if(!(this.foneToSend == 4)){
                number = this.foneToSend
            } else{
                number = this.newNumber
            }
            this.$emit('closeform', number)
        },

    },

    watch: {

    },

    components: {

    },

    created () {
        this.loadPart()
    },

    mounted () {
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    }

}

</script>

<template>
    <div id="mymodal" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container nb-email-container" style="max-width:500px">
            <div class="nb-modal-header">
                <h4 class="def-title">Selecione um contato para envio</h4>
                <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="nb-modal-scrollable-body">
                <div class="d-flex flex-column align-items-start justify-content-center" v-for="(contact, index) in part.partcontato" :key="index" v-if="part.partcontato">
                    <div class="d-flex mb-1" style="gap:20px" v-if="contact.fone1">
                        <input type="radio" :id="'customRadio_1'+index" v-model="foneToSend" :value="contact.fone1">
                        <div class="d-flex flex-column">
                            <label class=" lbl" :for="'customRadio_1'+index" style="line-height:18px; font-size: 15px; ">Enviar para {{contact.nomecontato}}</label>
                            <label class=" lbl" :for="'customRadio_1'+index" style="line-height:18px; font-size: 15px; word-break: break-all;">{{ contact.fone1 | formatFone }}</label>
                        </div>
                    </div>
                    <div class="d-flex mb-1" style="gap:20px" v-if="contact.fone2">
                        <input type="radio" :id="'customRadio_2'+index" v-model="foneToSend" :value="contact.fone2" >
                        <div class="d-flex flex-column">
                            <label class=" lbl" :for="'customRadio_2'+index" style="line-height:18px;font-size: 15px; ">Enviar para {{contact.nomecontato}}</label>
                            <label class=" lbl" :for="'customRadio_2'+index" style="line-height:18px; font-size: 15px; word-break: break-all;">{{ contact.fone2 | formatFone }}</label>
                        </div>
                    </div>
                    <div class="d-flex mb-1" style="gap:20px" v-if="contact.fone3">
                        <input type="radio" :id="'customRadio_3'+index" v-model="foneToSend" :value="contact.fone3" >
                        <div class="d-flex flex-column">
                            <label class=" lbl" :for="'customRadio_3'+index" style="line-height:18px; font-size: 15px; word-break: break-all;">{{ contact.fone3 | formatFone }}</label>
                            <label class=" lbl" :for="'customRadio_3'+index" style="line-height:18px; font-size: 15px; word-break: break-all;">{{ contact.fone3 | formatFone }}</label>
                        </div>
                    </div>
                </div>
                <div class="d-flex mb-1 align-items-center" style="gap:20px">
                    <input type="radio" id="customRadio999" style="margin-bottom:1rem" v-model="foneToSend" :value="4">
                    <div class="d-flex flex-column">
                        <label class=" lbl" for="customRadio999" style="line-height:18px; font-size: 15px; word-break: break-all;">Outro Número</label>
                        <form-field type="number" v-model="newNumber"></form-field>
                    </div>
                </div>
                <div class="nb-modal-scrollable-footer">
                    <v-button ref="btnConfirm" label="Enviar Mensagem" :disabled="!foneToSend" title="" :nb-btdef="true" @click="handleConfirmar()"></v-button>
                    <v-button ref="btnClose" label="Cancelar" title="" @click="closeModal"></v-button>
                </div>
            </div>
        </div>
    </div>

</template>


<style>


</style>



// WEBPACK FOOTER //
// src/components/fones-part-share.vue